"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

var _get_cat_tags = require("@/api/get_cat_tags");

var _get_feedback_by_id = require("@/api/get_feedback_by_id");

var _Upload = _interopRequireDefault(require("@/components/Upload"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getList } from '@/api/cat_list'
// import { getCat } from '@/api/get_cat_by_id'
// import { getCommonRecord } from '@/api/cat_record'
// import { fileUpload } from '@/api/file_upload'
// import UploadMultiple from '@/components/Upload/multiple'
var _default = {
  components: {
    Upload: _Upload.default
  },
  data: function data() {
    var _this = this;

    var validateRequire = function validateRequire(rule, value, callback) {
      if (!value) {
        _this.$message({
          message: rule.name + '都没填就点提交，打你啊！',
          type: 'error'
        });

        callback(new Error(rule.name + '为必传项'));
      } else {
        callback();
      }
    };

    var validateList = function validateList(rule, value, callback) {
      if (value && value.length == 0) {
        _this.$message({
          message: rule.name + '都没填就点提交，打你啊！',
          type: 'error'
        });

        callback(new Error(rule.name + '为必传项'));
      } else {
        callback();
      }
    };

    return {
      editFeedbackForm: {
        id: '',
        user_name: '',
        cat_name: '',
        tags: [],
        cat_age: '',
        cat_sex: '',
        img_list: [],
        _img_list: []
      },
      activeName: 'first',
      tags: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      editFeedbackFormRules: {
        user_name: [{
          required: true,
          name: '“主人名” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        cat_name: [{
          required: true,
          name: '“猫名字” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        tags: [{
          required: true,
          name: '“猫标签” ',
          trigger: 'blur',
          validator: validateList
        }],
        cat_age: [{
          required: true,
          name: '“猫年龄” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        cat_sex: [{
          required: true,
          name: '“猫性别” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        img_list: [{
          required: true,
          name: '“猫照片” ',
          trigger: 'blur',
          validator: validateList
        }]
      }
    };
  },
  created: function created() {
    this.listLoading = true;
    this.editFeedbackForm.id = this.$route.params.id;
    this.fetchData();
  },
  methods: {
    handleRemove: function handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload: function handleDownload(file) {
      console.log(file);
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var $ = this;
      (0, _get_cat_tags.getCatTags)().then(function (response) {
        var catTagsList = response.data;
        _this2.tags = catTagsList;
      });

      if (this.editFeedbackForm.id % 1 === 0) {
        // 如果id为数字尝试查找已存在的猫
        (0, _get_feedback_by_id.getFeedback)(this.editFeedbackForm.id).then(function (res_feedback) {
          var feedback = res_feedback.feedback;
          _this2.editFeedbackForm.user_name = feedback.user_name;
          _this2.editFeedbackForm.cat_name = feedback.cat_name;
          _this2.editFeedbackForm.tags = feedback.tags.split(',').map(Number);
          _this2.editFeedbackForm.cat_age = feedback.cat_age;
          _this2.editFeedbackForm.cat_sex = feedback.cat_sex; // this.editFeedbackForm._img_list = feedback.img_list.split('$$$')

          console.log(feedback.img_list.split('$$$')); // let img_list = feedback.img_list.split('$$$')

          feedback.img_list.split('$$$').map(function (item, index) {
            $.editFeedbackForm.img_list.push({
              url: item
            });
          }); // this.editFeedbackForm.img_list = img_list
          // console.log('sldfjklsdjkflsjdklfjklsd')
          // console.log(this.editFeedbackForm.img_list)
        });
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs.editFeedbackForm.validate(function (valid) {
        if (valid) {
          _this3.loading = true; // this.editFeedbackForm.img_list = this.editFeedbackForm._img_list.join("$$$")

          var img_list = [];

          _this3.editFeedbackForm.img_list.map(function (item, index) {
            if (item.url.indexOf("?hw=") != -1) {
              img_list[index] = item.url;
            } else {
              img_list[index] = item.url + '?hw=' + item.height_width;
            }
          });

          _this3.editFeedbackForm.img_list = img_list.join("$$$"); // console.log('sdfskjdkfjskldjfklsdjkl------')
          // console.log(this.editFeedbackForm.img_list)

          _this3.$store.dispatch('feedback/edit', _this3.editFeedbackForm).then(function (data) {
            _this3.$message({
              message: data.msg,
              type: 'success'
            });

            _this3.loading = false;

            _this3.$router.push({
              path: '/feedback/list'
            });
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onCancel: function onCancel() {
      this.$message({
        message: 'cancel!',
        type: 'warning'
      });
    },
    handleClick: function handleClick(tab, event) {// console.log(tab, event)
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传jpg图片');
        return false;
      }

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!');
        return false;
      }
    },
    onSuccess: function onSuccess(res, file, fileList) {
      this.editFeedbackForm['img_list'].push({
        url: res.msg,
        height_width: res.height_width
      });
      console.log('---------------------');
      console.log(this.editFeedbackForm['img_list']); // // let img_list = [];
      // // fileList.map(function (item, index) {
      // //   img_list[index] = item.response.msg
      // // })
      // // this.editFeedbackForm['img_list'] = fileList
      // console.log(res)
      // console.log(file)
    },
    onRemove: function onRemove(file, fileList) {
      this.editFeedbackForm['img_list'] = fileList;
      console.log(this.editFeedbackForm['img_list']); // let img_list = [];
      // fileList.map(function (item, index) {
      //   img_list[index] = item.response.msg
      // })
      // this.editFeedbackForm['img_list'] = img_list
      // console.log(this.editFeedbackForm['_img_list'])
    }
  }
};
exports.default = _default;